import {tns} from 'tiny-slider/src/tiny-slider';

class BannerSlider {
	constructor(el, prevButton, nextButton, nav, autoHeight = true) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;
		this.nav = nav;

		return tns({
			container: this.el,
			autoHeight: false,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 100,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			nav: true,
			navPosition: "bottom",
			navContainer: this.nav
		});

	}
}

export default BannerSlider;